import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: "root",
})
export class PermissionService {
  constructor(private authService: AuthenticationService) {}

  checkPermission(permissions: string[] = [], logicalOp = "AND") {
    return this.authService.currentUser$.pipe(
      map((user) => {
        let hasPermission = false;
        if (user && user.is_super_admin) {
          return true;
        }
        if (user && user.permissions) {
          for (const checkPermission of permissions) {
            // allow permissonf with : or .
            const checkPermissionArray = checkPermission.split(/[.:]/);
            const parsedValue = checkPermissionArray.join(".");
            const permissionFound = user.permissions.find(
              (x) => x.toUpperCase() === parsedValue.toUpperCase()
            );

            if (permissionFound) {
              hasPermission = true;

              if (logicalOp === "OR") {
                break;
              }
            } else {
              hasPermission = false;
              if (logicalOp === "AND") {
                break;
              }
            }
          }
        }
        return hasPermission;
      })
    );
  }
}
